export default __webpack_public_path__ + "static/media/cards-organic.771b37f6.png";